import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            wt: number
        }
    }
}

export default class Session extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>We observed Traces spending significant time with session operations.</p>

        if (message) {
            const { args } = message
            intro = (
                <p>
                    This trace has a Session bottleneck with{' '}
                    <strong>
                        <Milliseconds value={args.wt} />
                    </strong>{' '}
                    to start a session. This can happen for two reasons:
                </p>
            )
        }

        return (
            <div>
                {intro}

                <ol>
                    <li>The contents of the session are very large.</li>
                    <li>Concurrent requests to the same session id block each other.</li>
                </ol>

                <p>
                    When you make concurrent Ajax requests from the browser of a user, each of them will try to acquire a lock to the
                    session data.
                </p>

                <p>
                    <i>PHP prevents concurrent write access to the session data</i>, even if you use non-file based session drivers such as
                    Memcache.
                </p>

                <p>
                    You can unblock the sessions by calling the method
                    <code>session_write_close();</code>. This will write the current session data to storage and all changes to the
                    <code>$_SESSION</code> data afterwards are ignored/lost.
                </p>

                <ul>
                    <li>
                        PHP Documentation:{' '}
                        <a href="http://php.net/session_write_close" target="_blank" rel="noreferrer">
                            session_write_close()
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}
